export default "__VITE_ASSET__BCPG7EN7__"